/**
 * Pure parsing + shaping helpers for the `show_entities_at_location` tool
 * result. No React, no IO — the controller (ShowEntitiesAtLocationToolUI) and
 * the presentational view both consume these.
 */

export interface ShowEntitiesAtLocationArgs {
  location: string
  time?: string
  radius_km?: number
}

export interface LocationEntity {
  element_id: string
  name: string
  type: string
  latitude: number
  longitude: number
}

export interface ShowEntitiesAtLocationResult {
  status: 'ok' | 'empty' | 'error'
  location?: {
    name: string
    latitude: number
    longitude: number
  }
  time_range?: {
    start: string
    end: string
  }
  entities?: LocationEntity[]
  error?: string
}

export function parseResult(
  raw: ShowEntitiesAtLocationResult | string | undefined
): ShowEntitiesAtLocationResult | null {
  if (raw == null) return null
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as ShowEntitiesAtLocationResult
    } catch {
      return { status: 'error', error: raw }
    }
  }
  return raw
}

export function formatTimeRange(start: string, end: string): string {
  try {
    const startDate = new Date(start)
    const endDate = new Date(end)
    const sameDay = startDate.toDateString() === endDate.toDateString()

    if (sameDay) {
      return `${startDate.toLocaleDateString()} ${startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
    }
    return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
  } catch {
    return `${start} - ${end}`
  }
}
